<template>
  <div class="minW1060-auto bg-fff mag10 pad10">
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="待审核" name="1"></el-tab-pane>
      <el-tab-pane label="已审核" name="2"></el-tab-pane>
      <el-tab-pane label="未通过" name="3"></el-tab-pane>
    </el-tabs>

    <el-row class="text-left">

      <div class="dlblock-mb20 mr10">
        <span class="pr5">寻人标题</span>
        <el-input v-model.trim="title" placeholder="请输入寻人标题" style="width: 150px;"/>
      </div>

      <div class="dlblock-mb20 mr10" v-if="activeName == '2'">
        <span class="pr5">寻人类型</span>
        <el-input v-model.trim="type" placeholder="请输入寻人类型" style="width: 150px;"/>
      </div>

      <div class="dlblock-mb20 mr10">
        <span class="pr5">发布者</span>
        <el-input v-model.trim="nickName" placeholder="请输入发布者" style="width: 150px;"/>
      </div>

      <div class="dlblock-mb20 mr10">
        <span class="pr5">所属代理商</span>
        <el-input v-model.trim="agentName" placeholder="请输入所属代理商" style="width: 150px;"/>
      </div>

      <div class="dlblock-mb20 mr10">
        <span class="pr5">创建时间</span>
        <el-date-picker
            v-model="date"
            style="width: 300px;"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"/>
      </div>

      <div class="dlblock-mb20">
        <el-button type="primary" @click="pages.page = 1; getSearchPersonWebPageFn()">
          搜索
        </el-button>
      </div>
    </el-row>

    <el-table class="my-table" :data="tableData" v-loading="tableLoading" :header-row-class-name="'my-table-header'">
      <el-table-column align="center" prop="title" label="寻人标题"></el-table-column>
      <el-table-column align="center" prop="type" label="寻人类型"></el-table-column>
      <el-table-column align="center" prop="nickName" label="发布者"></el-table-column>
      <el-table-column align="center" prop="agentName" label="所属代理商"></el-table-column>
      <el-table-column align="center" prop="createTime" label="创建时间"></el-table-column>

      <template v-if="activeName == '2'">
        <el-table-column align="center" prop="" label="状态"></el-table-column>
      </template>
      <template v-else>
        <el-table-column align="center" prop="" label="未通过原因"></el-table-column>
      </template>

      <el-table-column align="center" label="操作">
        <template slot-scope="{row}">
          <a class="glob-a" v-if="activeName == '1'" @click="editBtn(1,row)">审核</a>
          <div v-else-if="activeName == '2'">
            <a class="glob-a" @click="editBtn(3,row)" >查看</a>
            <a class="glob-a" @click="editBtn(4,row)" >取消寻人</a>
          </div>
          <a class="glob-a" v-else @click="editBtn(3,row)" >查看</a>
        </template>
      </el-table-column>
    </el-table>

    <!-- 审核 -->
    <el-dialog title="审核" :visible.sync="auditShow.modal" width="800px">
      <el-form label-width="170px">

        <el-row>
          <el-col :span="12">
            <el-form-item label="寻人标题：">
                            {{data.title ? data.title : ''}}
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="寻人类型：">
              {{data.type ? data.type : ''}}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="毕业学校：">
              {{data.firstKeyWord ? data.firstKeyWord : ''}}
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="所学专业：">
              {{data.secondKeyWord ? data.secondKeyWord :'' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="毕业时间：">
              {{data.thirdKeyWord ? data.thirdKeyWord : ''}}
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="所在地址：">
              {{data.site ? data.site : ''}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系电话：">
              {{data.phone ? data.phone : ''}}
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="相关照片：">
              <div class="m-wrap" v-loading="imgListLoading">
                <div class="m-box" v-for="(item, index) in data.coverList" :key="index">
                  <el-image class="m-box-img" :src="item" @click="editBtn(5, item)" lazy></el-image>
                </div>
              </div>

            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="详细描述：">
                            {{data.context ? data.context :''}}
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="创建时间：">
              {{data.createTime ? data.createTime : ''}}
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="审核意见：">
              <el-radio v-model="radio"  label="PASS" >审核通过</el-radio>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="审核不通过：">
              <el-radio v-model="radio"  label="NOT_PASS" >&nbsp;</el-radio>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="未通过原因：" v-if="radio == 'NOT_PASS'" >
          <el-input v-model="remark" placeholder="请输入" type="textarea" :cols="2" :rows="4" resize="none">
            {{data.remark}}
          </el-input>
        </el-form-item>
      </el-form>

      <div slot="footer">
        <el-button @click="auditShow.modal = false">取 消</el-button>
        <el-button type="primary" @click="editBtn(2)">确 定</el-button>
      </div>
    </el-dialog>


    <!-- 查看 -->
    <el-dialog :title=" activeName == 2 ? '已审核' : '未通过' " :visible.sync="tailShow.modal" width="800px">

      <el-form label-width="170px">

        <el-row>
          <el-col :span="12">
            <el-form-item label="寻人标题：">
              {{data.title ? data.title : ''}} {{activeName}}
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="寻人类型：">
              {{data.type ? data.type : ''}}
            </el-form-item>
          </el-col>
        </el-row>

          <el-row>
          <el-col :span="12">
            <el-form-item label="毕业学校：">
              {{data.firstKeyWord ? data.firstKeyWord : ''}}
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="所学专业：">
              {{data.secondKeyWord ? data.secondKeyWord :'' }}
            </el-form-item>
          </el-col>
        </el-row>

      <el-row>
          <el-col :span="12">
            <el-form-item label="毕业时间：">
              {{data.thirdKeyWord ? data.thirdKeyWord : ''}}
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="所在地址：">
              {{data.site ? data.site : ''}}
            </el-form-item>
          </el-col>
        </el-row>

          <el-row>
          <el-col :span="12">
            <el-form-item label="联系电话：">
              {{data.phone ? data.phone : ''}}
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="相关照片：">
              <div class="m-wrap" v-loading="imgListLoading">
                <div class="m-box" v-for="(item, index) in data.coverList" :key="index">
                  <el-image class="m-box-img" :src="item" @click="editBtn(5, item)" lazy></el-image>
                </div>
              </div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="详细描述：">
              {{data.context ? data.context :''}}
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="创建时间：">
              {{data.createTime ? data.createTime : ''}}
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="状态：">
               {{ data.statusName ? data.statusName :'' }}
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="发布人：">
              {{ data.nickName ? data.nickName :'' }}
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="所属代理商：">
              {{ data.agentName ? data.agentName :'' }}
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="创建时间：">
              {{ data.createTime ? data.createTime :'' }}
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>

    <!-- 图片放大 -->
    <el-dialog title="查看" :visible.sync="imgPreData.modal" width="800px">
      <img style="width: 100%; height: auto;" :src="imgPreData.url" alt="">
    </el-dialog>

  </div>
</template>

<script>
  import MoreImg from '@/components/MoreImg.vue'
  import {
    getSearchPersonWebPage,
    getSearchPerson,
    getSearchPersonType,
    searchPersonAuditSuccess,
    searchPersonAuditFailed
  } from '@/api'
  export default {
    name: 'Lost',
    components: {MoreImg},
    data () {
      return {
        //审核状态
        radio:'',
        date: '',
        status: '1',
        tableData: [],
        tableLoading: false,
        activeName: '1',
        title:'',
        nickName:'',
        agentName:'',
        type:'',
        pages: {
          page: 1,
          total: 0
        },
        //审核
        auditShow:{
          type:'',
          searchPersonId:'',
          modal:false
        },
        //查看详情
        data:{},
        //关键字
        keyword:{},
        //未通过原因
        remark:'',
        //查看
        tailShow:{
          modal:false
        },
        // 图片放大
        imgPreData: {
          modal: false,
          url: ''
        },
        imgListLoading:false
      }
    },
    created () {
      this.getSearchPersonWebPageFn()
    },
    methods: {
      getSearchPersonWebPageFn () {
        this.tableLoading = true
        getSearchPersonWebPage({
          title:this.title,
          type:this.type,
          startTime:this.date && this.date.length ? this.date[0] : '',
          endTime:this.date && this.date.length > 1 ? this.date[1] : '',
          agentName:this.agentName,
          nickName:this.nickName,
          status:this.status,
          pageNum:this.pages.page
        }).then(res => {
          this.tableData = res.data.list
          this.pages.total = res.data.count
        }).finally(() => {
          this.tableLoading = false
        })
      },
      getSearchPersonFn () {
        this.tableLoading = true
        let id = this.auditShow.searchPersonId;
        getSearchPerson(id).then(res => {
          this.data = res.data
          this.imgListLoading = false
        }).finally(() => {
          this.tableLoading = false
        })
      },
      getSearchPersonTypeFn(){
        this.tableLoading = true
        let type = this.auditShow.type;
        getSearchPersonType(type).then(res => {
          this.keyword = res.data
        }).finally(() => {
          this.tableLoading = false
        })
      },
      //审核通过
      searchPersonAuditSuccessFn(id){
        searchPersonAuditSuccess(id).then(res => {
            if(res.code==200){
              this.auditShow.modal = false
            }
        }).finally(() => {
          this.tableLoading = false
        })
      },
      //审核失败
      searchPersonAuditFailedFn(id,remark){
        searchPersonAuditFailed({
          searchPersonId:id,
          remark:remark
        }).then(res => {
            if(res.code==200){
              this.auditShow.modal = false
            }
        }).finally(() => {
          this.tableLoading = false
        })
      },
      handleClick (val) {
        this.refresh(1);
      },
      refresh (page) {
        //page && (this.Pages.page = page)
        switch (this.activeName) {
          case '1':
            //待审核
            this.status = "1"
            break
          case '2':
            //已审核
            this.status = "2"
            break
          case '3':
            //未通过
            this.status = "3"
            break
        }
        this.getSearchPersonWebPageFn()
      },
      //1 审核查看 2审核确定 3查看 4取消寻人 5图片放大
      editBtn (t, row) {
        if( t == 1){
          this.imgListLoading = true
          this.auditShow = {
            searchPersonId:row.searchPersonId,
            modal:true,
            //关键字
            type:row.type
          }
          //关键字查询
          this.getSearchPersonTypeFn();
          //查看寻亲审核详情
          this.getSearchPersonFn();
        }else if(t == 2){
          let id = this.auditShow.searchPersonId;
          if(this.radio == 'PASS'){
            this.searchPersonAuditSuccessFn(id);
          }else{
            //审核不通过原因
            let remark = this.remark;
            this.searchPersonAuditFailedFn(id,remark);
          }
        }else if(t == 3){
          this.auditShow = {
            searchPersonId:row.searchPersonId,
            //关键字
            type:row.type
          }
          //关键字查询
          this.getSearchPersonTypeFn();
          //查看寻亲审核详情
          this.getSearchPersonFn();
          this.tailShow.modal = true;
        }else if(t == 4){
          this.$confirm(`取消后该条寻人信息将不再展示`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            let searchPersonId = row.searchPersonId;
           //调用取消寻人
            console.info(searchPersonId);
          });
        }else if(t == 5){
          this.imgPreData = {
            modal: true,
            url: row
          }
        }
      }
      }
  }
</script>

<style scoped>
  .m-wrap {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: flex-start;
  }

  .m-box {
    width: 240px;
    position: relative;
    margin: 10px;
  }

  .m-box:hover {
    transform: translateY(-2px);
  }

  .m-box-img {
    width: 100%;
    height: 160px;
    cursor: pointer;
  }
</style>

